import script from "./AdminMachinery.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMachinery.vue?vue&type=script&setup=true&lang=js"

import "./AdminMachinery.vue?vue&type=style&index=0&id=0330b5fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0330b5fc"]])

export default __exports__